import React from 'react';
import GPTLogoWhite from '@/assets/GPTforme Logo White.svg';

export const Footer: React.FC = () => {
    return (
        <div className="fixed bottom-0 left-0 right-0 bg-[#1a1a1a] border-t border-gray-600 z-30">
            <footer className="py-3 sm:py-4 px-3 sm:px-6">
                <div className="container mx-auto text-center">
                    <div className="flex items-center justify-center space-x-2 sm:space-x-3 mb-2">
                        <img
                            src={GPTLogoWhite}
                            alt="GPTforme Logo"
                            className="h-6 sm:h-8 md:h-10 w-auto"
                            onError={(e) => {
                                e.currentTarget.style.display = 'none';
                            }}
                        />
                    </div>
                    <p className="text-gray-400 text-xs sm:text-sm mb-2 sm:mb-3">The AI-powered shopping companion</p>
                    <div className="flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-6">
                        <a
                            href="/GPTforme_privacy_policy.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm"
                        >
                            Privacy
                        </a>
                        <a
                            href="/GPTforme_terms_of_use.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm"
                        >
                            Terms of Use
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
};